import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.34 6.021a.832.832 0 0 1-.633-.256L.213 1.272A.73.73 0 0 1 0 .75.7.7 0 0 1 .213.217.72.72 0 0 1 .74 0q.31 0 .527.217L5.34 4.291 9.413.216a.73.73 0 0 1 .522-.212.7.7 0 0 1 .532.212q.217.217.217.527a.72.72 0 0 1-.217.527L5.972 5.766a.83.83 0 0 1-.632.255"
    }, null, -1)
  ]))]))
}
export default { render: render }